export default __webpack_public_path__ + "locales/it/PortalUnavailable.json?hash=dd37f14d78bd7e8369eaae5d24200c8b";